/* ============================================================
   BAMBULEA · Sistema de favoritos (wishlist)
   Guardado en el navegador (localStorage). Sin login ni backend.
   ------------------------------------------------------------
   · Limpieza de favoritos ocultos/eliminados (404 -> se borran).
   · Cajón lateral con efecto cristal que se abre al añadir.
   · Desplegable de variante (color/talla) + añadir a la cesta rápido.
   · Integrado con el carrito real del tema (misma animación de burbuja).
   Textos, colores y título: Configuración del tema -> Favoritos.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'bambulea:wishlist:v1';
  var PCACHE = {};
  var validated = false;
  var _eventsMod;
  var _config = null;

  /* ---------- almacenamiento ---------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list, extra) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    var detail = { list: list };
    if (extra) { for (var k in extra) { if (extra.hasOwnProperty(k)) detail[k] = extra[k]; } }
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: detail }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    var added;
    if (i === -1) { list.push(handle); added = true; }
    else { list.splice(i, 1); added = false; }
    write(list, { added: added, handle: handle });
    return added;
  }
  function removeMany(handles) {
    if (!handles || !handles.length) return;
    var drop = {};
    handles.forEach(function (h) { drop[h] = 1; });
    var list = read().filter(function (h) { return !drop[h]; });
    write(list, { pruned: true });
  }

  /* ---------- consulta de producto (con detección de 404) ---------- */
  function fetchProduct(handle) {
    if (PCACHE[handle]) return Promise.resolve({ handle: handle, product: PCACHE[handle], gone: false });
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 404) return { handle: handle, product: null, gone: true };
        if (!r.ok) return { handle: handle, product: null, gone: false };
        return r.json().then(function (p) { PCACHE[handle] = p; return { handle: handle, product: p, gone: false }; });
      })
      .catch(function () { return { handle: handle, product: null, gone: false }; });
  }

  function validate() {
    if (validated) return;
    validated = true;
    var list = read();
    if (!list.length) return;
    Promise.all(list.map(fetchProduct)).then(function (rs) {
      var gone = rs.filter(function (x) { return x.gone; }).map(function (x) { return x.handle; });
      if (gone.length) removeMany(gone);
    });
  }

  /* ---------- configuración (Configuración del tema -> Favoritos) ---------- */
  function getConfig() {
    if (_config) return _config;
    var el = document.querySelector('[data-wl-config]') || document.querySelector('.wishlist-header');
    var d = (el && el.dataset) ? el.dataset : {};
    _config = {
      title: d.wlTitle || 'MIS FAVORITOS BAMBULEA',
      add: d.wlAdd || '¡Lo quiero!',
      added: d.wlAdded || '¡Añadido!',
      sold: d.wlSold || 'Agotado',
      empty: d.wlEmpty || 'Aún no has guardado ningún favorito.',
      money: d.wlMoney || '€{{amount}}',
      glass: d.wlGlass !== '0',
      openOnAdd: d.wlOpenOnAdd !== '0',
      btnBg: d.wlBtnBg || '#111111',
      btnText: d.wlBtnText || '#ffffff',
      btnRadius: d.wlBtnRadius || '8'
    };
    return _config;
  }

  /* ---------- utilidades ---------- */
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    var fmt = format || '€{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function number(value, precision, thousands, decimal) {
      if (isNaN(value) || value == null) return '0';
      value = (value / 100).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var match = fmt.match(placeholder);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = number(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = number(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = number(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = number(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = number(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = number(cents, 2, "'", '.'); break;
      default: value = number(cents, 2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }

  var HEART_SVG =
    '<svg class="wishlist-button__heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>' +
    '</svg><span class="wishlist-button__pulse" aria-hidden="true"></span>';

  var CLOSE_SVG =
    '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ---------- piezas de tarjeta compartidas ---------- */
  function imgSrc(p, w) {
    var img = p.featured_image
      ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image)
      : '';
    if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 600);
    return img;
  }
  function priceInner(p, money) {
    var price = formatMoney(p.price, money);
    var compare = (p.compare_at_price && p.compare_at_price > p.price)
      ? '<s class="wishlist-card__compare">' + formatMoney(p.compare_at_price, money) + '</s> '
      : '';
    return compare + price;
  }
  function variantSelectHTML(p) {
    var vs = p.variants || [];
    if (vs.length <= 1) return '';
    var firstAvail = null;
    for (var i = 0; i < vs.length; i++) { if (vs[i].available) { firstAvail = vs[i]; break; } }
    var opts = vs.map(function (v) {
      return '<option value="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || '') + '"' +
        (v.available ? '' : ' disabled') + (v === firstAvail ? ' selected' : '') + '>' +
        escapeHtml(v.title) + (v.available ? '' : ' — agotado') + '</option>';
    }).join('');
    return '<div class="wl-select"><select data-wl-variant aria-label="Elegir opción">' + opts + '</select>' +
      '<svg class="wl-select__chevron" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M6 9l6 6 6-6"/></svg></div>';
  }
  function addButtonHTML(p, c) {
    if (!p.available) {
      return '<button class="wishlist-card__cart" type="button" disabled>' + escapeHtml(c.sold) + '</button>';
    }
    var vs = p.variants || [];
    var attrs = 'data-add-to-cart data-label="' + escapeHtml(c.add) + '" data-added="' + escapeHtml(c.added) + '"';
    if (vs.length === 1) attrs += ' data-variant-id="' + vs[0].id + '"';
    return '<button class="wishlist-card__cart" type="button" ' + attrs + '>' + escapeHtml(c.add) + '</button>';
  }
  // Actualiza el precio mostrado al cambiar la variante seleccionada.
  function updatePriceFromSelect(sel, money) {
    var card = sel.closest('[data-handle]');
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = card.querySelector('[data-wl-price]');
    if (!opt || !priceEl) return;
    var pr = Number(opt.getAttribute('data-price'));
    var cmp = Number(opt.getAttribute('data-compare') || 0);
    var html = (cmp && cmp > pr ? '<s class="wishlist-card__compare">' + formatMoney(cmp, money) + '</s> ' : '') + formatMoney(pr, money);
    priceEl.innerHTML = html;
  }

  /* ---------- añadir a la cesta (integrado con el carrito del tema) ---------- */
  function loadCartEvents() {
    if (_eventsMod) return _eventsMod;
    _eventsMod = import('https://cdn.shopify.com/storefront/standard-events.js').catch(function () { return null; });
    return _eventsMod;
  }
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  async function addToCart(btn) {
    var card = btn.closest('[data-handle]');
    var sel = card ? card.querySelector('[data-wl-variant]') : null;
    var id = sel ? sel.value : btn.getAttribute('data-variant-id');
    if (!id || btn.getAttribute('data-busy') === '1') return;
    btn.setAttribute('data-busy', '1');
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.classList.add('is-loading');

    var mod = await loadCartEvents();
    var CLU = mod && mod.CartLinesUpdateEvent;
    var deferred = (CLU && CLU.createPromise) ? CLU.createPromise() : null;

    if (CLU && deferred) {
      document.dispatchEvent(new CLU({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: String(id), quantity: 1 }],
        promise: deferred.promise
      }));
    }

    var body = { items: [{ id: Number(id), quantity: 1 }] };
    var ids = cartSectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      var data = await res.json();

      if (!res.ok || data.status) {
        if (deferred) deferred.reject(new Error(data.description || 'add failed'));
        flash(btn, label, 'No disponible', 'is-error');
        return;
      }

      var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });

      if (deferred && CLU.createCartFromAjaxResponse) {
        deferred.resolve({
          cart: CLU.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items, itemCount: 1, source: 'wishlist', sourceId: 'wishlist',
            didError: false, sections: data.sections
          }
        });
      } else {
        var ci = document.querySelector('cart-icon');
        if (ci && ci.renderCartBubble) ci.renderCartBubble(cart.item_count);
      }

      flash(btn, label, btn.getAttribute('data-added') || '¡Añadido!', 'is-added');
    } catch (err) {
      if (deferred) deferred.reject(err);
      btn.classList.remove('is-loading');
      btn.removeAttribute('data-busy');
      btn.textContent = label;
    }
  }

  function flash(btn, label, message, cls) {
    btn.classList.remove('is-loading');
    btn.classList.add(cls);
    btn.textContent = message;
    setTimeout(function () {
      btn.textContent = label;
      btn.classList.remove(cls);
      btn.removeAttribute('data-busy');
    }, 1600);
  }

  /* ---------- cajón lateral de favoritos ---------- */
  var Drawer = {
    el: null, panel: null, grid: null, emptyEl: null, cfg: null, isOpen: false, _building: false,
    init: function () {
      if (this.el) return;
      var c = this.cfg = getConfig();
      var el = document.createElement('div');
      el.className = 'wl-drawer' + (c.glass ? ' wl-drawer--glass' : '');
      el.setAttribute('hidden', '');
      el.innerHTML =
        '<div class="wl-drawer__overlay" data-wl-close></div>' +
        '<aside class="wl-drawer__panel" role="dialog" aria-modal="true" aria-label="' + escapeHtml(c.title) + '" ' +
          'style="--wl-btn-bg:' + c.btnBg + ';--wl-btn-text:' + c.btnText + ';--wl-btn-radius:' + c.btnRadius + 'px;">' +
          '<header class="wl-drawer__head">' +
            '<h2 class="wl-drawer__title">' + escapeHtml(c.title) + '</h2>' +
            '<button class="wl-drawer__close" type="button" data-wl-close aria-label="Cerrar">' + CLOSE_SVG + '</button>' +
          '</header>' +
          '<div class="wl-drawer__body">' +
            '<div class="wl-drawer__grid" data-wl-grid></div>' +
            '<p class="wl-drawer__empty" data-wl-empty hidden>' + escapeHtml(c.empty) + '</p>' +
          '</div>' +
        '</aside>';
      document.body.appendChild(el);
      this.el = el;
      this.panel = el.querySelector('.wl-drawer__panel');
      this.grid = el.querySelector('[data-wl-grid]');
      this.emptyEl = el.querySelector('[data-wl-empty]');

      var self = this;
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-wl-close]')) { e.preventDefault(); self.close(); return; }
        var rm = e.target.closest('[data-wl-remove]');
        if (rm) {
          e.preventDefault();
          var card = rm.closest('[data-handle]');
          if (card) removeMany([card.getAttribute('data-handle')]);
          return;
        }
        var add = e.target.closest('[data-add-to-cart]');
        if (add) { e.preventDefault(); addToCart(add); return; }
      });
      el.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-wl-variant]');
        if (sel) updatePriceFromSelect(sel, self.cfg.money);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.isOpen) self.close(); });
      document.addEventListener('wishlist:change', function () { if (self.isOpen) self.render(); });
    },
    cardHTML: function (p) {
      var c = this.cfg;
      var img = imgSrc(p, 360);
      return (
        '<div class="wl-dcard" data-handle="' + escapeHtml(p.handle) + '">' +
          '<button class="wl-dcard__remove" type="button" data-wl-remove aria-label="Quitar de favoritos">' + CLOSE_SVG + '</button>' +
          '<a class="wl-dcard__media" href="' + p.url + '" aria-label="' + escapeHtml(p.title) + '">' +
            (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="wl-dcard__info">' +
            '<a class="wl-dcard__title" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
            variantSelectHTML(p) +
            '<p class="wl-dcard__price" data-wl-price>' + priceInner(p, c.money) + '</p>' +
            addButtonHTML(p, c) +
          '</div>' +
        '</div>'
      );
    },
    render: function () {
      if (!this.grid) return;
      var list = read();
      if (!list.length) { this.grid.innerHTML = ''; this.emptyEl.hidden = false; return; }
      var self = this;
      Promise.all(list.map(fetchProduct)).then(function (rs) {
        var gone = rs.filter(function (x) { return x.gone; }).map(function (x) { return x.handle; });
        if (gone.length) { removeMany(gone); return; }
        var products = rs.map(function (x) { return x.product; }).filter(Boolean);
        if (!products.length) { self.grid.innerHTML = ''; self.emptyEl.hidden = false; return; }
        self.emptyEl.hidden = true;
        self.grid.innerHTML = products.map(function (p) { return self.cardHTML(p); }).join('');
      });
    },
    show: function () {
      this.init();
      this.render();
      this.el.hidden = false;
      var el = this.el;
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      this.isOpen = true;
      document.documentElement.classList.add('wl-drawer-lock');
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.isOpen = false;
      document.documentElement.classList.remove('wl-drawer-lock');
      var el = this.el;
      var self = this;
      setTimeout(function () { if (!self.isOpen) el.hidden = true; }, 320);
    }
  };

  /* ---------- <wishlist-button> ---------- */
  if (!customElements.get('wishlist-button')) {
    customElements.define('wishlist-button', class extends HTMLElement {
      connectedCallback() {
        this.handle = this.getAttribute('data-handle');
        this.button = this.querySelector('button');
        if (!this.button) return;
        this._onClick = this.onClick.bind(this);
        this._onChange = this.sync.bind(this);
        this.button.addEventListener('click', this._onClick);
        document.addEventListener('wishlist:change', this._onChange);
        this.sync();
      }
      disconnectedCallback() {
        document.removeEventListener('wishlist:change', this._onChange);
      }
      onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        var added = toggle(this.handle);
        if (added) this.animate();
      }
      animate() {
        this.classList.remove('is-animating');
        void this.offsetWidth;
        this.classList.add('is-animating');
      }
      sync() {
        var active = has(this.handle);
        this.classList.toggle('is-active', active);
        if (this.button) {
          this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
          this.button.setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Añadir a favoritos');
        }
      }
    });
  }

  /* ---------- <wishlist-count> (burbuja en la cabecera) ---------- */
  if (!customElements.get('wishlist-count')) {
    customElements.define('wishlist-count', class extends HTMLElement {
      connectedCallback() {
        this._onChange = this.update.bind(this);
        document.addEventListener('wishlist:change', this._onChange);
        this.update();
        validate();
      }
      disconnectedCallback() {
        document.removeEventListener('wishlist:change', this._onChange);
      }
      update(evt) {
        var n = read().length;
        this.textContent = n;
        this.hidden = n === 0;
        if (evt && evt.detail && evt.detail.added) this.bump();
      }
      bump() {
        this.classList.remove('is-bumping');
        void this.offsetWidth;
        this.classList.add('is-bumping');
      }
    });
  }

  /* ---------- <wishlist-page> (página de favoritos) ---------- */
  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', class extends HTMLElement {
      connectedCallback() {
        this.cfg = {
          money: this.getAttribute('data-money-format') || getConfig().money,
          add: this.getAttribute('data-add-label') || '¡Lo quiero!',
          added: this.getAttribute('data-added-label') || '¡Añadido!',
          sold: this.getAttribute('data-soldout-label') || 'Agotado'
        };
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.empty = this.querySelector('[data-wishlist-empty]');
        this._onChange = this.render.bind(this);
        this._onClick = this.onClick.bind(this);
        this._onSelect = this.onSelect.bind(this);
        document.addEventListener('wishlist:change', this._onChange);
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onSelect);
        this.render();
      }
      disconnectedCallback() {
        document.removeEventListener('wishlist:change', this._onChange);
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onSelect);
      }
      onClick(e) {
        var btn = e.target.closest('[data-add-to-cart]');
        if (!btn || !this.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();
        addToCart(btn);
      }
      onSelect(e) {
        var sel = e.target.closest('[data-wl-variant]');
        if (sel) updatePriceFromSelect(sel, this.cfg.money);
      }
      async render() {
        if (!this.grid) return;
        var list = read();
        if (!list.length) {
          this.grid.innerHTML = '';
          if (this.empty) this.empty.hidden = false;
          return;
        }
        var rs = await Promise.all(list.map(fetchProduct));
        var gone = rs.filter(function (x) { return x.gone; }).map(function (x) { return x.handle; });
        if (gone.length) { removeMany(gone); return; }
        var products = rs.map(function (x) { return x.product; }).filter(Boolean);
        if (!products.length) {
          this.grid.innerHTML = '';
          if (this.empty) this.empty.hidden = false;
          return;
        }
        if (this.empty) this.empty.hidden = true;
        var self = this;
        this.grid.innerHTML = products.map(function (p) { return self.cardHTML(p); }).join('');
      }
      cardHTML(p) {
        var c = this.cfg;
        var img = imgSrc(p, 600);
        return (
          '<div class="wishlist-card" data-handle="' + escapeHtml(p.handle) + '">' +
            '<a class="wishlist-card__link" href="' + p.url + '" aria-label="' + escapeHtml(p.title) + '">' +
              '<div class="wishlist-card__media">' +
                (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
              '</div>' +
            '</a>' +
            '<wishlist-button class="wishlist-button" data-handle="' + escapeHtml(p.handle) + '">' +
              '<button type="button" class="wishlist-button__btn" aria-pressed="true" aria-label="Quitar de favoritos">' +
                HEART_SVG +
              '</button>' +
            '</wishlist-button>' +
            '<div class="wishlist-card__info">' +
              '<a class="wishlist-card__title-link" href="' + p.url + '"><p class="wishlist-card__title">' + escapeHtml(p.title) + '</p></a>' +
              variantSelectHTML(p) +
              '<p class="wishlist-card__price" data-wl-price>' + priceInner(p, c.money) + '</p>' +
              addButtonHTML(p, c) +
            '</div>' +
          '</div>'
        );
      }
    });
  }

  /* ---------- disparadores globales ---------- */
  // Abre el cajón al AÑADIR un favorito (no al quitar).
  document.addEventListener('wishlist:change', function (e) {
    if (e.detail && e.detail.added && getConfig().openOnAdd) Drawer.show();
  });
  // El corazón de la cabecera abre el cajón (la página sigue existiendo por su URL).
  document.addEventListener('click', function (e) {
    var h = e.target.closest('.wishlist-header');
    if (h) { e.preventDefault(); Drawer.show(); }
  });

  // API mínima
  window.BambuleaWishlist = {
    read: read, has: has, toggle: toggle, removeMany: removeMany, validate: validate,
    openDrawer: function () { Drawer.show(); }, closeDrawer: function () { Drawer.close(); }
  };
})();
